module.exports = __webpack_public_path__ + "img/card2.bcf7a8d7.png";